import { AppStepSection } from '../../types/app_data';
import { getAddCarSteps } from '../common/addcars';

// List of adding car steps for /policy flow (cars & drivers on same page).
export const AddCarOnboardingSteps = getAddCarSteps({
  flowFilter: (appData) => {
    if (appData.addingNewCar) {
      return true;
    }

    if (appData.stepSection === AppStepSection.Challenge) {
      return !appData.cars || appData.cars.length === 0;
    }

    // If user is from partner signup and already prefilled cars, skip this step
    if (
      appData.signupParams?.partnerSignup &&
      !!appData.partnerSkippableData?.cars &&
      appData.partnerSkippableData.cars.length > 0
    ) {
      return false;
    }
    return (
      !!appData.selectedService?.insurance && (!appData.searchPolicyData || appData.searchPolicyData.cars.length === 0)
    );
  },
});
